import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Circle, CircleData } from "../../../types/wizard";

type CircleIndicatorProps = {
  circle: Circle,
  isTarget: boolean;
  indications?: CircleData[],
  color: string;
  contrastColor: string;
  hoveredColorId?: number;
  onClick: (position: { x: number; y: number } | null, color: string) => void;
};

export const CircleIndicator: React.FC<CircleIndicatorProps> = (
  { circle, isTarget, indications, color, contrastColor, hoveredColorId, onClick }) => {
  const { id, x, y } = circle;
  const left = x;
  const top = y;
  const className = `absolute cursor-pointer hover:scale-110 ${isTarget && 'flex flex-row justify-center items-center text-[1.5em] pb-1'}`;
  const matchedIndication = indications?.find((i) => i?.circle?.id === id);
  const dimension = matchedIndication?.dimension;
  const shouldShowIcon = !isTarget && dimension;

  const renderIcon = () => {
    if (!shouldShowIcon) return null;

    const icon =
      dimension === "High" ? (
        <FontAwesomeIcon icon={faArrowUp} color={contrastColor} />
      ) : dimension === "Low" ? (
        <FontAwesomeIcon icon={faArrowDown} color={contrastColor} />
      ) : null;

    return (
      <span className="flex justify-center items-center text-[1.4em]">
        {icon}
      </span>
    );
  };

  return (<div
    className={className}
    style={{
      left: `${left}px`,
      top: `${top}px`,
      width: '28px',
      height: '28px',
      borderRadius: '50%',
      backgroundColor: isTarget ? '#FFF' : color,
      border: !isTarget ? `3px solid ${contrastColor}` : '2px solid #ccc',
      transform: hoveredColorId && hoveredColorId === circle?.id ? 'scale(1.2)' : 'none'
    }}
    onMouseEnter={() => onClick({ x: left, y: top }, color)}
    onMouseLeave={() => onClick(null, '')}
  >{isTarget && '+'}
    {renderIcon()}
  </div>)
}
